import { render } from "./UserIndex.vue?vue&type=template&id=c0e3c32c&scoped=true"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"

import "./UserIndex.vue?vue&type=style&index=0&id=c0e3c32c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e3c32c"]])

export default __exports__